import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
	name: "user",
	initialState: { user: null, loading: true },
	reducers: {
		userExist: (state, action) => {
			state.user = action.payload;
			state.loading = false;
		},
		userNotExist: (state) => {
            state.loading = false;
            state.user = null;
        },
	},
});

export const { userExist, userNotExist } = userSlice.actions;